// Product switch for the standalone 3D editor deployment.
// Keep the original Scratch 2D editor code available underneath, but do not expose it in this build.
const THREE_D_ONLY_EDITOR = true;

export {
    THREE_D_ONLY_EDITOR
};
